import {
  af,
  ar,
  bg,
  bs,
  da,
  de,
  el,
  enGB,
  enUS,
  es,
  et,
  fi,
  fr,
  hi,
  hr,
  hu,
  is,
  it,
  ja,
  ka,
  kk,
  ko,
  lt,
  lv,
  mk,
  ms,
  nb,
  nl,
  pl,
  pt,
  ro,
  sk,
  sl,
  sq,
  sr,
  sv,
  th,
  tr,
  uk,
  vi,
  zhCN,
  zhHK,
} from 'date-fns/locale';
import localeCurrency from 'locale-currency';
import { baseUrlCDN } from '../constants';

export const localeMap: { [key: string]: Locale } = {
  'en-US': enUS,
  'en-GB': enGB,
  'da-DK': da,
  'de-DE': de,
  'sv-SE': sv,
  'es-ES': es,
  'es-MX': es,
  'it-IT': it,
  'sl-SI': sl,
  'fr-FR': fr,
  'nl-NL': nl,
  'is-IS': is,
  'fi-FI': fi,
  'pt-PT': pt,
  'pl-PL': pl,
  'kk-KZ': kk,
  'hu-HU': hu,
  'sk-SK': sk,
  'ro-RO': ro,
  'et-EE': et,
  'lt-LT': lt,
  'lv-LV': lv,
  'ko-KR': ko,
  'ja-JP': ja,
  'el-GR': el,
  'bg-BG': bg,
  'th-TH': th,
  'zh-CN': zhCN,
  'zh-HK': zhHK,
  'vi-VN': vi,
  'ms-MY': ms,
  'af-ZA': af,
  'uk-UA': uk,
  'sq-AL': sq,
  'hr-HR': hr,
  'bs-BA': bs,
  'mk-MK': mk,
  'ka-GE': ka,
  'sr-RS': sr,
  ar: ar,
  'tr-TR': tr,
  'hi-IN': hi,
  'nb-NO': nb,
};

export const CURRENCIES = ['SEK', 'USD', 'EUR', 'INR', 'CAD', 'DKK'];

export const currencySymbolMap: Record<string, string> = {
  SEK: 'kr',
  USD: '$',
  EUR: '€',
  INR: '₹',
  CAD: '$',
  DKK: 'kr',
};

const fallbackCurrencyToCountryMap: Record<string, string> = {
  USD: 'united_states',
  EUR: 'europe',
  SEK: 'sweden',
  DKK: 'denmark',
  INR: 'india',
};

export const getFlagUrlFromCurrency = (currencyCode: string) => {
  const countries = localeCurrency.getLocales(currencyCode.toUpperCase());

  let countryName: string | undefined;

  if (countries?.length) {
    const regionCode = countries[0].slice(-2);
    countryName = new Intl.DisplayNames(['en'], { type: 'region' })
      .of(regionCode)
      ?.toLowerCase()
      .replace(/[\s-]/g, '_');
  }

  // Override with fallback if defined or if countryName not reliable
  if (fallbackCurrencyToCountryMap[currencyCode.toUpperCase()]) {
    countryName = fallbackCurrencyToCountryMap[currencyCode.toUpperCase()];
  }

  // Final fallback
  if (!countryName) {
    countryName = 'sweden';
  }

  return `${baseUrlCDN}/flags/${countryName}.svg${process.env.REACT_APP_CDN_TOKEN ?? ''}`;
};

const countryFlag = new Intl.DisplayNames('en', { type: 'region' });

export const getFlagUrlFromLanguage = (language: string) => {
  if (language === 'es-MX') {
    return `${baseUrlCDN}/flags/latin_america.svg${process.env.REACT_APP_CDN_TOKEN ?? ''}`;
  }

  if (language === 'tr-TR') {
    return `${baseUrlCDN}/flags/turkey.svg${process.env.REACT_APP_CDN_TOKEN ?? ''}`;
  }

  if (language === 'ar') {
    return `${baseUrlCDN}/flags/saudiarabia.svg${process.env.REACT_APP_CDN_TOKEN ?? ''}`;
  }

  const regionCode = language.split('-')[1]?.toUpperCase();
  let countryName: string | undefined;

  if (regionCode) {
    try {
      countryName = countryFlag.of(regionCode)?.toLowerCase().replace(/[\s-]/g, '_');
    } catch {
      countryName = undefined;
    }
  }

  if (!countryName) {
    countryName = 'sweden';
  }

  return `${baseUrlCDN}/flags/${countryName}.svg${process.env.REACT_APP_CDN_TOKEN ?? ''}`;
};
